// React
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
// Locales
import translate from 'locales/i18n';
// Material UI
import { withStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';

import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import ExportIcon from '@mui/icons-material/CloudDownload';
import ClearIcon from '@mui/icons-material/Clear';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import { Collapse } from '@mui/material';

class DialogExportAccount extends React.PureComponent {

    state = {
        name: this.props.account ? this.props.account.name + '-data' : 'pcp-data',
        separator: ';',
        exportType: 'accountInfos',
        period: '50'
    };

    static propTypes = {
        classes: PropTypes.object.isRequired,
        open: PropTypes.bool,
        exportData: PropTypes.func,
        fullScreen: PropTypes.bool,
        account: PropTypes.object,
        close: PropTypes.func
    };

    handleChange = prop => event => {
        this.setState({ [prop]: event.target.value });

        if (prop === 'exportType' && event.target.value === 'additionalData' && (this.state.separator === ',' || this.state.separator === '.')) this.setState({ separator: ';' });
    };

    exportData = () => {
        const name = this.state.name === '' ? 'pcp-data' : this.state.name;

        const options = {
            fieldSeparator: this.state.separator,
            filename: name,
            quoteStrings: '',
            decimalseparator: ',',
            showLabels: true,
            showTitle: false,
            useBom: true,
            useKeysAsHeaders: true,
            exportType: this.state.exportType,
            period: this.state.period
        };

        this.props.exportData(options, this.props.account.id);
        this.props.close();
    };

    render() {
        const { fullScreen, classes } = this.props;

        return (
            <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.props.close}
                disableRestoreFocus={true}
                aria-labelledby='responsive-dialog-title'
            >
                <IconButton color='secondary' onClick={this.props.close} className={classes.closeButton}>
                    <ClearIcon />
                </IconButton>
                <DialogTitle id='responsive-dialog-title'>{translate.i18n('EXPORT_DATA')}</DialogTitle>
                <DialogContent className={classNames(!fullScreen && classes.dialogContentNotFullScreen, classes.dialogContent)}>
                    <TextField
                        id='filename'
                        className={classNames(classes.textField)}
                        variant='outlined'
                        type='text'
                        label={translate.i18n('FILE_NAME')}
                        value={this.state.name}
                        onChange={this.handleChange('name')}
                    />
                    <FormControl>
                        <FormLabel>Exporter : </FormLabel>
                        <RadioGroup
                            value={this.state.exportType}
                            onChange={this.handleChange('exportType')}
                            className={classes.radioButton}>
                            <FormControlLabel value='accountInfos' control={<Radio color='primary' />} label='Le compte' />
                            <FormControlLabel value='additionalData' control={<Radio color='primary' />} label='Les données aditionelles' />
                        </RadioGroup>
                    </FormControl>
                    <FormControl variant='outlined' className={classNames(classes.textField)}>
                        <InputLabel
                            ref={ref => {
                                this.InputLabelRef = ref;
                            }}
                        >
                            {translate.i18n('SEPARATOR')}
                        </InputLabel>
                        <Select
                            native
                            label={translate.i18n('SEPARATOR')}
                            value={this.state.separator}
                            onChange={this.handleChange('separator')}
                        >
                            <option value={','}>,</option>
                            <option value={';'}>;</option>
                            {this.state.exportType !== 'additionalData' && <option value={'.'}>.</option>}
                            <option value={'|'}>|</option>
                        </Select>
                    </FormControl>
                    <Collapse in={this.state.exportType === 'additionalData'}>
                        <TextField
                            id='period'
                            className={classNames(classes.textField)}
                            variant='outlined'
                            type='number'
                            label='Periode (nb jours)'
                            value={this.state.period}
                            onChange={this.handleChange('period')}
                        />
                    </Collapse>
                </DialogContent>
                <DialogActions>
                    <Button color='primary' size='small'
                        onClick={this.exportData}>
                        <ExportIcon className={classes.leftIcon} />
                        Exporter
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const styles = theme => ({
    dialogContent: {
        display: 'flex',
        flexDirection: 'column',
        width: '450px'
    },
    dialogContentNotFullScreen: {
        display: 'flex',
        justifyContent: 'center',
        minHeight: '200px',
        minWidth: '300px',
        paddingLeft: '10%',
        paddingRight: '10%'
    },
    textField: {
        marginTop: theme.spacing(1),
        marginBottom: theme.spacing(1),
        width: '100%'
    },
    radioButton: {
        marginLeft: theme.spacing(1)
    },
    closeButton: {
        position: 'absolute',
        right: '2px',
        top: '2px'
    },
    leftIcon: {
        marginRight: theme.spacing(1),
        fontSize: 20
    },
});

export default withStyles(styles)(DialogExportAccount);
